import React, { useContext, useState } from "react";
import DiscountForm from "../components/Discount/DiscountForm";
import { Button, Steps, theme } from "antd";
import { context } from "../context/context";
import DiscountUploadMedia from "../components/Discount/DiscountUploadMedia";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import { http } from "../services/httpService";
import config from "../services/config.json";
import { NavLink } from "react-router-dom";

const steps = [
    {
        title: "اضافه کردن جزئیات تخفیف",
        content: <DiscountForm />,
    },
    {
        title: "انتخاب عکس",
        content: <DiscountUploadMedia />,
    },
];
const AddDiscount = () => {
    //context
    const {
        discountTitle,
        discountDescription,
        discountLinks,
        discountTags,
        setDiscountMedia,
        setDiscountMediaId,
        setDiscountCover,
        discountMediaId,
        discountCoverId,
    } = useContext(context);
    const { token } = theme.useToken();
    // state
    const [current, setCurrent] = useState(0);

    //functions
    const next = () => {
        setCurrent(current + 1);
    };
    const navigate = useNavigate();
    const handleSubmit = () => {
        http.post(`${config.parkopoloApi}/api/Discount/addDiscount`, {
            links: discountLinks,
            description: discountDescription,
            title: discountTitle,
            tags: discountTags,
            media: discountMediaId,
        })
            .then((res) => {
                toast.success("تخفیف با موفقیت ساخته شد !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    progress: undefined,
                    theme: "colored",
                    style: { fontFamily: "Vazir" },
                });
                console.log(res.data.success);
            })
            .catch((err) => {
                toast.error("خطایی رخ داد !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    progress: undefined,
                    theme: "colored",
                    style: { fontFamily: "Vazir" },
                });
                console.log(err);
            });
        setDiscountMedia([]);
        setDiscountMediaId([]);
        setDiscountCover();
        navigate("/discount", { replace: true });
    };
    const items = steps.map((item) => ({
        key: item.title,
        title: item.title,
    }));
    const contentStyle = {
        lineHeight: "260px",
        textAlign: "center",
        color: token.colorTextTertiary,
        backgroundColor: token.colorFillAlter,
        borderRadius: token.borderRadiusLG,
        border: `1px dashed ${token.colorBorder}`,
        marginTop: 16,
    };
    return (
        <div style={{ direction: "ltr" }}>
            <Steps current={current} items={items} />
            <div style={contentStyle}>{steps[current].content}</div>
            <div
                style={{
                    marginTop: 24,
                    textAlign: "left",
                    display: "flex",
                    gap: 10,
                }}
            >
                {current < steps.length - 1 && (
                    <Button
                        type="primary"
                        onClick={() => next()}
                        disabled={
                            !discountTitle ||
                            !discountDescription ||
                            discountLinks.length === 0
                        }
                    >
                        مرحله بعد
                    </Button>
                )}
                {current === steps.length - 1 && (
                    <Button
                        disabled={!discountCoverId || discountCoverId === ""}
                        type="primary"
                        onClick={() => handleSubmit()}
                    >
                        ثبت
                    </Button>
                )}
                {
                    <NavLink to="/discount">
                        <Button type="primary" danger>
                            لغو
                        </Button>
                    </NavLink>
                }
            </div>
        </div>
    );
};

export default AddDiscount;
